import styled from 'styled-components';
import global from '../../global';
// OLD IFRAME LAYOUT

interface IContentAreaProps {
  readonly isMenuOpen: boolean;
}

export const PageContainer = styled.div<IContentAreaProps>`
  width: 100%;
  max-height: 9999px; // this is used to make the animation smoother
  background-color: var(--background);
  transition: transform 0.25s ease-in-out, border-radius 0.25s ease-in-out, margin 0.25s ease-in-out, max-height 0.25s ease-in-out;

  .content-area {
    position: relative;
    height: 70vh;
    padding-top: 60px;
  }

  ${props => props.isMenuOpen
    ? `
    max-height: 100vh;
    overflow: hidden;
    position: relative;`
    : ``}

  @media(max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    min-height: 100%;
    padding-left: 0;

    .content-area {
      padding-bottom: 8vw;
    }
  }
`

export const PageHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  gap: 12px;
  padding: 0 2vw;

  svg {
    cursor: pointer;
    color: var(--fixit);
    font-size: 30px;
  }
`;

export const PageTitle = styled.h1`
  font-family: Roboto, sans-serif;
  font-size: 24px;
  font-weight: bold;
  color: var(--fixit);
  margin: 0;
`;
